import React from "react";
import { useTranslation } from "react-i18next";

function Pricing() {
  const { t } = useTranslation();

  return (
    <main className="page">
      <section className="page-hero">
        <div className="page-hero-content">
          <h1>{t("nav.pricing")}</h1>
          <p>Bảng giá dịch vụ chuyển phát quốc tế</p>
        </div>
      </section>

      <section className="page-container">
        <p>Trang bảng giá - Nội dung sẽ được cập nhật</p>
      </section>
    </main>
  );
}

export default Pricing;
